
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import Logo from '../utils/Logo';
import Nodata from '../utils/NoData';
import { useDispatch } from "react-redux";

const CustomError = () => {

  return (
    <>

    <Box sx={{width:'100vw', height:'100vh', display:'grid',textAlign:'center',justifyContent:'center'}}>
     <div style={{margin:'auto',textAlign:'center',display:'flex',flexFlow:'column'}}>
     <div style={{margin:'auto',textAlign:'center',display:'flex', marginBottom:5}}>
     <Logo sx={{margin:'auto',display:'inline-flex'}} />
     </div>
     
     <h1>No result found</h1>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
      <Nodata/>
      <div style={{margin:'auto',textAlign:'center',display:'flex',}}>
      <Button variant="contained" sx={{width:150}}>Back to Login</Button>
      </div>
     </div>
      
      
    </Box>

    </>
  )
}

export default CustomError;